const getters = {
  current: (state: any) => state,
  token: (state: any) => state.token,
  isValid: (state: any) => state.isValid,
};

export default getters;
